import { useEffect, useRef } from 'react'

export const useEffectAfterRender = (func, dependencies) => {
  const didMount = useRef(false)

  useEffect(() => {
    didMount.current ? func() : didMount.current = true
  }, dependencies)
}
